<template>
  <div class="pos-task-body">
    <div class="pos-task-completed">
      {{ $t('kdu.completed') }}:
      <b>({{ completeCooking }}/{{ getProductInTable.length }})</b>
    </div>
    <div class="pos-task-product-row">
      <div class="pos-task-product" v-for="(product, index) in getProductInTable" :key="index">
        <div class="pos-task-product-img">
          <!-- <div
            class="cover ts-border ts-border-gray-100"
            :style="{
              'background-image':`url(${product.image})`
            }"
          ></div> -->
          <div class="cover">
            <img
              class="ts-absolute ts-object-cover ts-h-full ts-w-full"
              :src="product.image"
              @error="setAltImg"
              alt
            />
          </div>
          <div class="caption" v-if="product.cooking_status_id == 3">
            <div>{{ $t('kdu.completed') }}</div>
          </div>
        </div>
        <div class="pos-task-product-info">
          <div class="info">
            <div class="title">{{ product.product_name_en }}</div>
            <div class="desc">
              - {{ $t('kdu.size') }} : {{ product.uom_name_en }}
              <br />
              - {{ $t('kdu.remark') }} : {{ product.remarks }}
              <br />
            </div>
          </div>
          <div class="qty">x{{ product.quantity }}</div>
        </div>
        <div class="pos-task-product-action">
          <button
            class="btn btn-success ts-w-full"
            :disabled="product._deleting || product.cooking_status_id == 3"
            @click.prevent="onComplete(product)"
          >
            <i class="fa fa-spinner spin" v-if="product._deleting"></i>
            {{ $t('kdu.complete') }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex'
export default {
  props: ['table'],
  data(){
    return {
      product_error: require('@/assets/default-product.jpg')
    }
  },
  computed: {
    ...mapState('restaurantSale/kdu', ['resources']),
    getProductInTable() {
      return this.resources.filter(r => r.table_id == this.table.table_id)
    },
    completeCooking() {
      return this.resources.filter(
        r => r.table_id == this.table.table_id && r.cooking_status_id == 3
      ).length
    }
  },
  methods: {
    ...mapMutations('restaurantSale/kdu', ['SET_STATUS_COMPLETE']),
    onComplete(record) {
      record._deleting = true
      this.$store
        .dispatch('restaurantSale/kdu/update', {
          id: record.stock_out_id,
          data: record
        })
        .then(response => {
          this.SET_STATUS_COMPLETE(record)
          this.$forceUpdate()
          // this.$toasted.success(response.message)
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          record._deleting = false
        })
    },
    setAltImg(event) { 
      event.target.src = this.product_error
    } 
  }
}
</script>